
<div class="contact-card">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-12">
                <h4 class="mt-5">
                    <span>
                        Select Your List Once, and We'll Ensure it Lands Straight in Your Inbox
                    </span>
                </h4>
                <br>
                <h4><span>Sounds Good?</span></h4>
                <img src="assets/img/inbox-flight.svg" class="flight-path" alt="">
            </div>
            <div class="col-md-6 col-12">
                <form>
                    <div class="form-group">
                      <input type="text" class="form-control dark-form" id="inputName" aria-describedby="name" placeholder="Enter Name">
                    </div>
                    <div class="form-group">
                      <input type="email" class="form-control dark-form" id="inputEmail" aria-describedby="emailHelp" placeholder="Enter email">
                    </div>
                    <div class="form-group">
                      <input type="number" class="form-control dark-form" id="inputPhone" aria-describedby="phoneHelp" placeholder="Enter Phone No.">
                      <small id="phoneHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
                    </div>

                    <button type="submit" class="btn brand-button" style="width: 100%;">
                      <img src="assets/img/send.svg" alt="" style="width: 1.5rem; margin-right: 0.5rem">
                      Send</button>
                  </form>
            </div>
        </div>
    </div>
</div>
